// extracted by mini-css-extract-plugin
export var root = "related-pages-module--root--325s3";
export var listItem = "related-pages-module--listItem--1zpfZ";
export var headline = "related-pages-module--headline--2ryX5";
export var grid = "related-pages-module--grid--1lU4e";
export var related_pages = "related-pages-module--related_pages--uvx-v";